import { defineMessages } from 'react-intl';

const multiFactorAuthenticationTranslations = defineMessages({
    ng_MFA_authenticationMethod: {
        id: 'identityServer.MFA.authenticationMethod',
        defaultMessage: 'Authentication Method',
    },
    ng_MFA_selectAuthenticationMethod: {
        id: 'identityServer.MFA.selectAuthenticationMethod',
        defaultMessage: 'Select authentication method',
    },
    ng_MFA_header: {
        id: 'identityServer.MFA.header',
        defaultMessage: 'Multi-Factor Authentication',
    },
    ng_MFA_appSetupHeader: {
        id: 'identityServer.MFA.appSetupHeader',
        defaultMessage: 'Multi Factor Authentication',
    },
    ng_MFA_appSetupQrDescription: {
        id: 'identityServer.MFA.appSetupQrDescription',
        defaultMessage:
            'Scan the QR code below using your Authenticator App. Once the QR code has been scanned and the CodeRed account has been created, enter the code in the text input below.',
    },
    ng_MFA_appSetupManualDescription: {
        id: 'identityServer.MFA.appSetupManualDescription',
        defaultMessage: 'Alternatively you can create the account manually by entering the key below into your app.',
    },
    ng_MFA_enterCode: {
        id: 'identityServer.MFA.enterCode',
        defaultMessage: 'Enter code',
    },
    ng_MFA_useSmsInstead: {
        id: 'identityServer.MFA.useSmsInstead',
        defaultMessage: 'Use SMS Instead',
    },
    ng_MFA_useAuthenticator: {
        id: 'identityServer.MFA.useAuthenticator',
        defaultMessage: 'Use Authenticator',
    },
    ng_MFA_skipForNow: {
        id: 'identityServer.MFA.skipForNow',
        defaultMessage: 'Skip for Now',
    },
    ng_MFA_submit: {
        id: 'identityServer.MFA.submit',
        defaultMessage: 'Submit',
    },
    ng_MFA_description: {
        id: 'identityServer.MFA.description',
        defaultMessage:
            'Multi Factor Authentication is required for system access.  Select authentication method and complete registration.',
    },
    ng_MFA_devices_SMS: {
        id: 'identityServer.MFA.devices_SMS',
        defaultMessage: 'SMS ',
    },
    ng_MFA_devices_MSAuth: {
        id: 'identityServer.MFA.devices_MSAuth',
        defaultMessage: 'Microsoft Authenticator',
    },
    ng_MFA_smsNumber: {
        id: 'identityServer.MFA.smsNumber',
        defaultMessage: 'SMS number',
    },
    ng_MFA_selectSmsNumber: {
        id: 'identityServer.MFA.selectSmsNumber',
        defaultMessage: 'Select SMS number',
    },
    ng_MFA_enterAuthCodeDescription: {
        id: 'identityServer.MFA.enterAuthCodeDescription',
        defaultMessage: 'Please enter the Authentication code sent to',
    },
    ng_MFA_authenticationCode: {
        id: 'identityServer.MFA.authenticationCode',
        defaultMessage: 'Authentication Code',
    },
    ng_MFA_enterAuthCodePlaceholder: {
        id: 'identityServer.MFA.enterAuthCodePlaceholder',
        defaultMessage: 'Enter authentication code',
    },
    ng_MFA_wrongAuthCode: {
        id: 'identityServer.MFA.wrongAuthCode',
        defaultMessage: 'Authentication code is incorrect',
    },
    ng_MFA_invalidAuthenticatorPin: {
        id: 'identityServer.MFA.invalidAuthenticatorPin',
        defaultMessage: 'You have entered an invalid Code. Please try again.',
    },
    ng_MFA_resendCode: {
        id: 'identityServer.MFA.resendCode',
        defaultMessage: 'Resend code',
    },
    ng_MFA_authenticate: {
        id: 'identityServer.MFA.authenticate',
        defaultMessage: 'Authenticate',
    },
    ng_MFA_setupSuccessMessage: {
        id: 'identityServer.MFA.setupSuccessMessage',
        defaultMessage:
            'You have completed setup of Multi-Factor Authentication. You may edit this within your user settings.',
    },
    ng_MFA_enterVerificationCodeDescription: {
        id: 'identityServer.MFA.enterVerificationCodeDescription',
        defaultMessage: 'Enter the verification code sent to {number} to access your account.',
    },
    ng_MFA_clickToResendPin: {
        id: 'identityServer.MFA.clickToResendPin',
        defaultMessage: 'Resend Pin',
    },
    ng_MFA_appVerificationDescription: {
        id: 'identityServer.MFA.appVerificationDescription',
        defaultMessage:
            'Please enter the 6 digit verification code from your selected Authenticator app to access CodeRed',
    },
    ng_MFA_cantSeeMyCode: {
        id: 'identityServer.MFA.cantSeeMyCode',
        defaultMessage: "I can't see my code",
    },
    ng_MFA_returnToLogin: {
        id: 'identityServer.MFA.returnToLogin',
        defaultMessage: 'Return to login',
    },
    ng_MFA_accountLockedTitle: {
        id: 'identityServer.MFA.accountLockedTitle',
        defaultMessage: 'Account Locked',
    },
    ng_MFA_accountLockedMessage: {
        id: 'identityServer.MFA.accountLockedMessage',
        defaultMessage:
            "Your account has been locked after exceeding the maximum number of login attempts. Please contact your Organization's Administrator or contact Customer Support to regain access to your account.",
    },
    ng_MFA_accountLockedSupportLabel: {
        id: 'identityServer.MFA.accountLockedSupportLabel',
        defaultMessage: 'Customer Support:',
    },
    ng_MFA_accountLockedSupportPhone: {
        id: 'identityServer.MFA.accountLockedSupportPhone',
        defaultMessage: 'Toll Free: +1 866-939-0911',
    },
    ng_mfa_smsVerificationNeeded: {
        id: 'identityServer.MFA.smsVerificationNeeded',
        defaultMessage: 'SMS Verification Needed!',
    },
    ng_MFA_noSmsDevicesConfigured: {
        id: 'identityServer.MFA.noSmsDevicesConfigured',
        defaultMessage:
            'Your account does not contain any SMS devices. Please contact your system administrator for futher assistance.',
    },
    ng_MFA_cantSeeMyCode_title: {
        id: 'identityServer.MFA.cantSeeMyCode_title',
        defaultMessage: 'Trouble with your code?',
    },
    ng_MFA_cantSeeMyCode_text: {
        id: 'identityServer.MFA.cantSeeMyCode_text',
        defaultMessage:
            "Make sure your device's time is set to Automatic so it stays in sync with the authenticator app.",
    },
    ng_MFA_cantSeeMyCode_contactAdmin: {
        id: 'identityServer.MFA.cantSeeMyCode_contactAdmin',
        defaultMessage: 'Still not working? Contact your administrator to reset your MFA pairing.',
    },
    ng_MFA_ok: {
        id: 'identityServer.MFA.ok',
        defaultMessage: 'OK',
    },
});

export default multiFactorAuthenticationTranslations;
